module.exports = __webpack_public_path__ + "static/media/Exchange_rate.7a2d7eed.svg";